interface MyLogoProps {
  fill: string;
  id: string;
  onClick?: () => void;
}

export const MyLogo = (props: MyLogoProps) => {
  return (
<svg width="200" height="40" viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg">
  <text x="30" y="24" font-family="Press Start 2P" font-size="24" fill="white">tobAIs</text>
</svg>

  );
};

